<div class="wrapper">

  <button
    mat-icon-button
    class="icon-left"
    tabindex="-1"
    aria-hidden="true"
  >
    <mat-icon>search</mat-icon>
  </button>

  <input
    matInput
    type="text"
    [formControl]="searchCtrl"
    [matAutocomplete]="auto"
    class="search-input"
    [placeholder]="placeholder()"
  />

  @if (searchCtrl && searchCtrl.value) {
    <button
      mat-icon-button
      class="icon-right"
      (click)="onClear()"
      aria-label="Limpiar"
    >
      <mat-icon svgIcon="cancel-contrast"></mat-icon>
    </button>
  }

  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onSelect($event.option.value)"
  >
    @for ( item of filteredList(); track $index ) {
      <mat-option
        [value]="item"
        [id]="getIdValue(item)"
      >
        {{ getLabelValue(item) }}
      </mat-option>
    }
  </mat-autocomplete>
</div>
